import { useUI } from "providers/UIProvider"

import { RESPONSE_MODAL_VARIANTS } from "./ResponseModalTypes"

import { Box, Flex, Text } from "@chakra-ui/react"
import Modal from "components/UI/organisms/Modal"
import Icon from "components/UI/atoms/Icon"

import SuccessCard from "components/UI/molecules/SuccessCard"
import { UI_INITIAL_STATE } from "providers/UIProvider/UIProviderConstants"

const ResponseModal: React.FC = () => {
  const { modals, toggleModal, T } = useUI()

  const title = modals.responseModal.data?.title || ""

  return (
    <Modal
      isOpen={modals.responseModal.isOpened}
      onClose={()=>toggleModal("responseModal", false, UI_INITIAL_STATE.modals.responseModal.data)}
      styles={{ width: "540px" }}
    >
      <Box h="450px">
        {modals.responseModal.data?.variant === RESPONSE_MODAL_VARIANTS.SUCCESS && <SuccessCard />}
        {modals.responseModal.data?.variant === RESPONSE_MODAL_VARIANTS.WARNING && (
          <Flex w="100%" h="100%" bg="white" justifyContent="center" alignItems="center" flexDirection="column">
            <Icon name="warning" iconStyles={{ width: "160px", height: "160px", fill: "var(--chakra-colors-warning)" }} />
            <Text mt="40px" fontWeight="600" fontSize="xl">{title || T("general.warning_message")}</Text>
          </Flex>
        )}

      </Box>
    </Modal>
  )
}

export default ResponseModal 